import axios from 'axios';

import { FORMS_API_URL } from 'constants/api';

const formsAPI = axios.create({
  baseURL: FORMS_API_URL,
});

export default formsAPI;
